import React, { useState, useEffect } from "react";
import { getAllItemsSearch } from "../../api/endpoints/search";
import {
  getVoucher,
  saveData,
  getData,
  descSale,
  updateSale,
  deleteSingleSale,
  deleteSale,
  ascSale,
  oneDayPrevious,
  oneDayNext,
} from "../../api/endpoints/lubeSale.js";
import { AiFillSave } from "react-icons/ai";
import { AiFillDelete } from "react-icons/ai";
import { AiFillEdit } from "react-icons/ai";
import { AiFillFileAdd } from "react-icons/ai";
import { BiExit } from "react-icons/bi";

import SideBar from "../sidebar/sideBar";
import "./lubeSale.css";
import { authSelector } from "../../store/selectors/index";
import { Modal, message } from "antd";
import { Button, Dropdown, Select, Menu } from "antd";
import { useSelector } from "react-redux";
import Popup from "../modals/Popup";
import {
  getItemRate,
  getRemainingItemQuantity,
} from "../../api/endpoints/item";
import { latestDate } from "../../api/endpoints/meter.js";

const { Option } = Select;

const LubeSale = () => {
  const { user, access_token } = useSelector(authSelector);

  const [voucher, setVoucher] = useState();
  //   const [voucherType] = useState("CV");
  const [type, setType] = useState("ADD");
  const [dateEntered, setDateEntered] = useState("");
  const [shift, setShift] = useState("");
  const [itemsQueue, setItemsQueue] = useState([]);
  const [editedItem, setEditedItem] = useState(null);
  const [fieldsShow, setFieldsShow] = useState(false);
  const [total, setTotal] = useState();
  const [remainingQuantity, setRemainingQuantity] = useState();
  const [isVisible, setIsVisible] = useState(true);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  console.log(type, "type");

  // -------------------------- STATE ----------

  const [state, setState] = useState({
    items: [],
    code: "",
    name: "",
    quantity: "",
    saleRate: "",
    purchaseRate: "",
    cashAmount: "",
  });

  const clearState = () => {
    setIsVisible(true);
    setState({
      items: state.items,
      code: "",
      name: "",
      quantity: "",
      saleRate: "",
      purchaseRate: "",
      cashAmount: "",
    });
  };

  const clearStates = () => {
    clearState();
    setEditedItem(null);
    setFieldsShow(false);
    setItemsQueue([]);
    setShift("");
    setDateEntered("");
    setVoucher("");
    setTotal(0);
    setType("ADD");
  };

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };

  // ------------------- ADD VOUCHER ---------------

  const addVoucher = async () => {
    if (!dateEntered) return message.error("Please type date !");
    const payload = {
      enteredOn: dateEntered,
    };
    const result = await getVoucher(payload, access_token);
    if (result.success) {
      setVoucher(result.data);
      setType("SAVE");
       setIsVisible(false);
      setFieldsShow(true);
    } else {
      message.error(result.message);
    }
  };
  // ------------------ SAVE DATA -----------------
  console.log(state, "state-=-=-=", type);

  const getLatestDate = async () => {
    const _date = await latestDate(access_token);
    setDateEntered(_date.data.enteredOn);
    setShift(_date.data.shift);
    // console.log(_date, "Dateee");
  };
  useEffect(() => {
    getLatestDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const save = async () => {
    if (!shift) return message.error("Please type shift!");
    if (itemsQueue.length === 0) return message.error("Add minimun 1 Entry");
    setIsButtonDisabled(true);


    const payload = itemsQueue.reduce((acc, curr) => {
      return [
        ...acc,
        {
          enteredOn: dateEntered,
          shift: Number(shift),
          itemCode: curr.code,
          itemName: curr.name,
          quantity: Number(curr.quantity),
          purchaseRate: Number(curr.purchaseRate),
          saleRate: Number(curr.saleRate),
          cashAmount: Number(curr.cashAmount),
          voucherNumber: Number(voucher),
          grpId: Number(user.grpId),
          siteId: Number(user.siteId),
          companyCode: Number(user.companyCode),
        },
      ];
    }, []);

    try {
      const result = await saveData(payload, access_token);
      if (result.success) {
        clearStates();
        message.success(result.message || "Successfully entered!");
      } else {
        message.error(result.message || "Failed to save!");
      }
    } catch (error) {
      console.error("Error while saving:", error);
    } finally {
      setIsButtonDisabled(false); // Re-enable the button after the async operation completes

      // Enable the button again, whether the API call succeeds or fails
    }
  };

  // ---------------- ALL ITEMS ----------------

  const getAllData = async () => {
    const _items = await getAllItemsSearch(access_token);
    setState({
      ...state,
      items: _items,
    });
  };
  useEffect(() => {
    getAllData();
    if (itemsQueue.length === 0) return;

    let totalAmount = itemsQueue.reduce(
      (arr, curr) => arr + Number(curr?.cashAmount || 0),
      0
    );
    setTotal(Number(totalAmount));

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsQueue]);

  const getItemsaleRate = async () => {
    const data = await getItemRate(state.code, access_token);
    if (data.success) {
      setState({
        ...state,
        // tanks: data.data,
        saleRate: data.data.saleRate,
        purchaseRate: data.data.purchaseRate,
      });
    }
  };
  const getRemainingQuantity = async () => {
    const requestData = {
      endingDate: dateEntered,
      itemCode: state.code,
    };
    const data = await getRemainingItemQuantity(requestData, access_token);
    if (data.success) {
      setRemainingQuantity(data.data);
      // setState({
      //   ...state,
      //   // tanks: data.data,
      //   saleRate: data.data.saleRate,
      //   purchaseRate: data.data.purchaseRate,
      // });
    }
  };
  useEffect(() => {
    if (state.code) {
      getItemsaleRate();
      getRemainingQuantity();
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.code]);

  console.log(remainingQuantity, "totttt");

  // ---------------------- ADD ITEM TO QUEUE --------------

  const addItem = () => {
    console.log(state.quantity, "yuytreqq");
    if (
      !state.code ||
      !state.quantity ||
      Number(state.quantity) === 0 ||
      !state.saleRate ||
      state.quantity > remainingQuantity
    ) {
      return message.error(
        `${
          !state.quantity
            ? "add minimum 1 quantity"
            : !state.saleRate
            ? "Sale Rate"
            : state.quantity > remainingQuantity
            ? "No balance available for sale"
            : !state.code
            ? "Please type Item"
            : Number(state.quantity) === 0
            ? "Quantity must be greater then 0"
            : ""
        }`
      );
    } else {
      setItemsQueue([...itemsQueue, state]);
      clearState();
      const nextInput = inputRefs["itemCode"];
      if (nextInput) {
        nextInput.focus();
      }
    }
  };

  console.log(itemsQueue, "items queue-=-=--=");
  // -------- EDIT ITEM

  const editItem = async () => {
    if (state.id) {
      if (
        !state.code ||
        !state.quantity ||
        Number(state.quantity) === 0 ||
        !state.saleRate ||
        state.quantity > remainingQuantity
      ) {
        return message.error(
          `${
            !state.quantity
              ? "add minimum 1 quantity"
              : !state.saleRate
              ? "Sale Rate"
              : state.quantity > remainingQuantity
              ? "No balance available for sale"
              : !state.code
              ? "Please type Item"
              : Number(state.quantity) === 0
              ? "Quantity must be greater then 0"
              : ""
          }`
        );
      }
      await updateSingleApi();
    } else {
      if (
        !state.code ||
        !state.quantity ||
        Number(state.quantity) === 0 ||
        !state.saleRate ||
        state.quantity > remainingQuantity
      ) {
        return message.error(
          `${
            !state.quantity
              ? "add minimum 1 quantity"
              : !state.saleRate
              ? "Sale Rate"
              : state.quantity > remainingQuantity
              ? "No balance available for sale"
              : !state.code
              ? "Please type Item"
              : Number(state.quantity) === 0
              ? "Quantity must be greater then 0"
              : ""
          }`
        );
      }
      itemsQueue[editedItem] = state;
      setItemsQueue([...itemsQueue]);
      setEditedItem(null);
      clearState();
    }
  };

  // -------- EDIT ITEM

  const deleteItem = (index) => {
    // const prevObject = itemsQueue[i]
    itemsQueue.splice(index, 1);
    setItemsQueue([...itemsQueue]);
    setEditedItem(null);
    console.log("deleteItem");
    clearState();
  };

  // ---------------------- EDIT API ------------------

  const [editPopup, setEditpopup] = useState(false);
  const edit = () => {
    setEditpopup(true);
  };

  const editHandler = async () => {
    if (!voucher) return message.error("Please type voucher number!");
    const results = await getData(voucher, access_token);
    if (results.success) {
      console.log(results, "ressaaaaa");
      const payload = results.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            code: curr.itemCode,
            name: curr.item.itemName,
            quantity: Number(curr.quantity),
            purchaseRate: Number(curr.purchaseRate),
            saleRate: Number(curr.saleRate),
            cashAmount: Number(curr.cashAmount),
            items: state.items,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setEditpopup(false);
      setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  // ---------------------- EDIT SINGLE API ------------------

  const updateSingleApi = async () => {
    const payload = {
      id: state.id,
      itemCode: state.code,
      itemName: state.name,
      quantity: Number(state.quantity),
      purchaseRate: Number(state.purchaseRate),
      saleRate: Number(state.saleRate),
      cashAmount: Number(state.cashAmount),
    };

    console.log(payload, "payyyyyyyyy");
    const response = await updateSale(payload, access_token);
    if (response.success) {
      await editHandler();
      message.success(response.message);
      clearState();
      setFieldsShow(false);
    } else {
      message.error(response.message);
    }
  };

  // ---------------- DELETE PURCHASE

  // -------- single

  const [modal, contextHolder] = Modal.useModal();
  const deleteSinglePurchase = async (id) => {
    console.log("deleteSingle");
    const results = await deleteSingleSale(id, access_token);
    if (results.success) {
      if (itemsQueue.length !== 1) {
        await editHandler();
      } else {
        setItemsQueue([]);
      }
      message.success("Record Deleted Successfully !");
      // clearStates()
    } else {
      message.error(results.message);
    }
  };

  const confirmDelete = (id) => {
    modal.confirm({
      title: `Confirm`,
      content: "Are you sure you want to delete this Record?",
      okText: "Delete",
      cancelText: "Cancel",
      onOk: () => deleteSinglePurchase(id),
    });
  };

  // -------- whole data

  const [deletePopup, setDeletepopup] = useState(false);
  const deletePurchase = () => {
    setDeletepopup(true);
  };

  const deletePurchaseHandler = async () => {
    const results = await deleteSale(voucher, access_token);
    if (results.success) {
      clearStates();
      message.success("Record Deleted Successfully !");
      clearStates();
      setDeletepopup(false);
    } else {
      message.error(results.message);
    }
  };
  const confirmDeleteAll = () => {
    modal.confirm({
      title: `Confirm`,
      content: "Are you sure you want to delete this Voucher?",
      okText: "Delete",
      cancelText: "Cancel",
      onOk: () => deletePurchaseHandler(),
    });
  };

  //----------------order by desc----------------------
  const descVoucher = async () => {
    const results = await descSale(access_token);
    console.log(results, "ressaaaaa");
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            code: curr.itemCode,
            name: curr.item.itemName,
            quantity: Number(curr.quantity),
            purchaseRate: Number(curr.purchaseRate),
            saleRate: Number(curr.saleRate),
            cashAmount: Number(curr.cashAmount),
            voucher: curr.voucherNumber,
            items: state.items,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(results.data[0].enteredOn);
      setVoucher(results.data[0].voucherNumber);
      setShift(results.data[0].shift);

      // setEditpopup(false);
      // setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  const ascVoucher = async () => {
    const results = await ascSale(access_token);
    console.log(results, "ressaaaaa");
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            code: curr.itemCode,
            name: curr.item.itemName,
            quantity: Number(curr.quantity),
            purchaseRate: Number(curr.purchaseRate),
            saleRate: Number(curr.saleRate),
            cashAmount: Number(curr.cashAmount),
            voucher: curr.voucherNumber,
            items: state.items,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(results.data[0].enteredOn);
      setVoucher(results.data[0].voucherNumber);
      setShift(results.data[0].shift);

      // setEditpopup(false);
      // setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  const onePreVoucher = async () => {
    const data = {
      enteredOn: dateEntered,
      shift,
      voucherNumber: voucher,
    };
    const results = await oneDayPrevious(data, access_token);
    console.log(results, "ressaaaaa");
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            code: curr.itemCode,
            name: curr.item.itemName,
            quantity: Number(curr.quantity),
            purchaseRate: Number(curr.purchaseRate),
            saleRate: Number(curr.saleRate),
            cashAmount: Number(curr.cashAmount),
            voucher: curr.voucherNumber,
            items: state.items,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(results.data[0].enteredOn);
      setVoucher(results.data[0].voucherNumber);
      setShift(results.data[0].shift);

      // setEditpopup(false);
      // setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  const oneNextVoucher = async () => {
    const data = {
      enteredOn: dateEntered,
      shift,
      voucherNumber: voucher,
    };
    const results = await oneDayNext(data, access_token);
    console.log(results, "ressaaaaa");
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            code: curr.itemCode,
            name: curr.item.itemName,
            quantity: Number(curr.quantity),
            purchaseRate: Number(curr.purchaseRate),
            saleRate: Number(curr.saleRate),
            cashAmount: Number(curr.cashAmount),
            voucher: curr.voucherNumber,
            items: state.items,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(results.data[0].enteredOn);
      setVoucher(results.data[0].voucherNumber);
      setShift(results.data[0].shift);

      // setEditpopup(false);
      // setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  const menu = (index) => {
    return (
      <Menu>
        <Menu.Item key="0">
          <button
            onClick={() => {
              setFieldsShow(true);
              setEditedItem(index);
              setState(itemsQueue[index]);
              console.log(itemsQueue, "edit");
            }}
          >
            Edit
          </button>
        </Menu.Item>
        {type === "SAVE" ? (
          <Menu.Item key="1">
            <button
              onClick={() => {
                deleteItem(index);
              }}
            >
              {" "}
              Delete
            </button>
          </Menu.Item>
        ) : (
          <Menu.Item key="1">
            <button
              onClick={() => {
                confirmDelete(itemsQueue[index].id);
              }}
            >
              {" "}
              Delete
            </button>
          </Menu.Item>
        )}
      </Menu>
    );
  };

  const inputRefs = {};
  const addInputFieldRef = (ref, fieldName) => {
    if (ref && fieldName) {
      inputRefs[fieldName] = ref;
    }
  };
  const handleEnterKey = (e, fieldName) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default behavior of the "Enter" key

      // Trigger addItem function if the current field is "amount"
      if (fieldName === "cashAmount") {
        Boolean(editedItem != null) ? editItem() : addItem();
      } else {
        const currentFieldName = fieldName;

        // Define the order of input fields
        const fieldOrder = [
          "dateEntered",
          "shift",
          "itemCode",
          "quantity",
          "saleRate",
          "cashAmount",
          // Add more field names as needed
        ];

        // Find the index of the current field in the order array
        const currentIndex = fieldOrder.indexOf(currentFieldName);
        console.log(currentIndex, "current Inddd");
        if (currentIndex !== -1 && currentIndex < fieldOrder.length - 1) {
          // Move focus to the next input field
          const nextFieldName = fieldOrder[currentIndex + 1];
          const nextInput = inputRefs[nextFieldName];

          if (nextInput) {
            nextInput.focus();
          }
        }
      }
    }
  };

  return (
    <div className="flex  bg-black lube-main">
      <SideBar />
      <div className="h-full  flex flex-col content-center  w-full">
        <div className="meterTableMain ml-10 mt-6o mr-10">
          {contextHolder}
          <div className="bg-blue-500 headingBox flex justify-between">
            <h3 className=" text-white tableHeading ml-10">LUBE SALE</h3>
            <input
              readOnly
              value={voucher}
              className="inpTxt inpTxtVoucher p-2 h-8 mr-10 mt-3 mb-3 w-40"
            />
          </div>
          <div className="bg-blue-500">
            <div
              className="flex content-center ml-11 pb-3 "
              style={{
                display: "flow-root",
              }}
            >
              <input
                type="date"
                value={dateEntered}
                className="text-black inpTxt p-2 mt-3 h-8  mb-3 w-40"
                onChange={(e) => setDateEntered(e.target.value)}
                onKeyDown={(e) => handleEnterKey(e, "dateEntered")}
                ref={(ref) => addInputFieldRef(ref, "dateEntered")}
              />
              <input
                type="number"
                name="shift"
                value={shift}
                placeholder="Shift"
                className=" text-black inpTxt mt-3 p-1 h-8 ml-3 w-40"
                onChange={(e) => setShift(e.target.value)}
                onKeyDown={(e) => handleEnterKey(e, "shift")}
                ref={(ref) => addInputFieldRef(ref, "shift")}
              />
              <input
                readOnly
                value={user.id}
                className="inpTxt text-black p-1 mt-3 h-8 ml-3 w-40"
              />
              <input
                value={user.name}
                className="inpTxt text-black p-1 mt-3 h-8 ml-3 w-64"
              />
              <input
                readOnly
                placeholder="Report no#"
                className="inpTxt text-black p-1 mt-3 h-8 ml-3 w-52"
              />
            </div>
          </div>
          {fieldsShow && (
            <div className="">
              <div className="flex content-center flex-wrap ml-10">
                <Select
                  className="ant-select bg-black text-white  mt-2 inpTxt  p-1 h-9  w-96 "
                  showSearch
                  name="itemCode"
                  placeholder="Select item"
                  optionFilterProp="children"
                  value={state.code || "Item"}
                  onChange={(e) => {
                    const { itemName: productName } = state.items.find(
                      (el) => el.itemCode === e
                    );
                    setState({ ...state, code: e, name: productName });
                  }}
                  onKeyDown={(e) => handleEnterKey(e, "itemCode")}
                  ref={(ref) => addInputFieldRef(ref, "itemCode")}
                >
                  {state.items.map((el) => (
                    <Option
                      value={el.itemCode}
                    >{`${el.itemCode} - ${el.itemName}`}</Option>
                  ))}
                </Select>
                {/* <Select
                  className="ant-select bg-black text-white mt-2 ml-3 inpTxt  p-1 h-9  w-52 "
                  showSearch
                  placeholder="Select Product Name"
                  optionFilterProp="children"
                  value={state.name || "Prodct Name"}
                  onChange={(e) => {
                    const { itemName: productName } = state.items.find(
                      (el) => el.itemCode === e
                    );
                    setState({ ...state, code: e, name: productName });
                  }}
                >
                  {state.items.map((el) => (
                    <Option value={el.itemCode}>{el.itemName}</Option>
                  ))}
                </Select> */}

                <input
                  type="text"
                  name="quantity"
                  value={state.quantity}
                  onChange={(e) => {
                    if (state.saleRate) {
                      setState({
                        ...state,
                        cashAmount: e.target.value * state.saleRate,
                        quantity: e.target.value,
                      });
                    } else {
                      setState({ ...state, quantity: e.target.value });
                    }
                  }}
                  placeholder="Qty"
                  className=" bg-black text-white inpTxt p-2 mt-2  h-9 ml-3 pt-3 w-36"
                  onKeyDown={(e) => handleEnterKey(e, "quantity")}
                  ref={(ref) => addInputFieldRef(ref, "quantity")}
                />
                <input
                  type="number"
                  name="saleRate"
                  value={state.saleRate}
                  onChange={(e) => {
                    if (state.quantity) {
                      setState({
                        ...state,
                        cashAmount: e.target.value * state.quantity,
                        saleRate: e.target.value,
                      });
                    } else {
                      setState({ ...state, saleRate: e.target.value });
                    }
                  }}
                  placeholder="S/Rate"
                  className="bg-black text-slate-400 inpTxt mt-2  p-2 h-9 ml-3 pt-3 w-64"
                  onKeyDown={(e) => handleEnterKey(e, "saleRate")}
                  ref={(ref) => addInputFieldRef(ref, "saleRate")}
                />
                <input
                  hidden
                  type="text"
                  name="purchaseRate"
                  value={state.purchaseRate}
                  onChange={onChangeText}
                  placeholder="Purchase Rate"
                  className="bg-black text-slate-400 inpTxt mt-2 p-2 h-9 ml-3 pt-3 w-28"
                />

                <input
                  type="number"
                  name="cashAmount"
                  id=""
                  value={state.cashAmount}
                  onChange={(e) => {
                    if (state.quantity) {
                      setState({
                        ...state,
                        saleRate: e.target.value / state.quantity,
                        cashAmount: e.target.value,
                      });
                    } else {
                      setState({ ...state, cashAmount: e.target.value });
                    }
                  }}
                  placeholder="Amount"
                  className="bg-black text-slate-400 inpTxt p-2 h-9 ml-3 mt-2  pt-3  w-36"
                  onKeyDown={(e) => handleEnterKey(e, "cashAmount")}
                  ref={(ref) => addInputFieldRef(ref, "cashAmount")}
                />

                {Boolean(editedItem != null) ? (
                  <button
                    onClick={editItem}
                    className="bg-blue-500 hover:bg-blue-700 text-white mt-2  h-9 ml-3 py-1 px-4 rounded"
                  >
                    EDIT
                  </button>
                ) : (
                  <button
                    onClick={addItem}
                    className="bg-blue-500 hover:bg-blue-700 text-white h-9 mt-2  ml-3 py-1 px-4 text-xs font-medium rounded"
                  >
                    ADD +
                  </button>
                )}
              </div>
            </div>
          )}

          <div className="div">
            <div className="flex">
              <div className="overflow-x-auto   shadow-md sm:rounded-lg tableDiv p-5 pl-10  w-full">
                <table className=" w-full text-sm text-left text-gray-500 dark:text-gray-400">
                  <thead className="bg-blue-500 text-white uppercase dark:bg-gray-700 tableHeading  dark:text-gray-400">
                    <tr>
                      <th
                        className=" pl-2 pr-2 fs-15 py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        SNo.
                      </th>
                      <th
                        className=" pr-2 fs-15 py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        Item
                      </th>
                      <th
                        className="  pl-2 pr-2 fs-15 py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        Item Name
                      </th>
                      <th
                        className="  pl-2 pr-2 fs-15 py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        Quantity
                      </th>
                      <th
                        className=" pl-2 pr-2 fs-15 py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        S/Rate
                      </th>
                      <th
                        className="  pl-2 pr-2 fs-15 py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        Amount
                      </th>
                      {(type === "EDIT" || type === "SAVE") && (
                        <th
                          className=" pl-2 pr-2 fs-15 py-3   bg-blue-500  text-left text-xs font-medium "
                          scope="col"
                        >
                          ACTION
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody className="tableBody">
                    {itemsQueue.map((ele, i) => {
                      return (
                        <tr key={i} className="tbodyData text-white">
                          <td className="pl-3 pt-3 pb-3">{i + 1}</td>
                          <td className="  pl-2 pr-2 fs-15 py-3     text-left text-xs font-medium   ">
                            <p className="">{ele.code}</p>
                          </td>{" "}
                          <td className="pl-3 pt-3 pb-3">
                            <p className="">{ele.name}</p>
                          </td>
                          <td className="pl-3 pt-3 pb-3">
                            <p className="">{ele.quantity}</p>
                          </td>
                          <td className="pl-3 pt-3 pb-3">
                            <p className="">{ele.saleRate}</p>
                          </td>
                          <td className="pl-3 pt-3 pb-3">
                            <p className="">{ele.cashAmount}</p>
                          </td>
                          <td className="pt-3 pb-3">
                            {(type === "SAVE" || type === "EDIT") && (
                              <Dropdown
                                overlay={menu(i)}
                                placement="bottomLeft"
                              >
                                <Button>Action</Button>
                              </Dropdown>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <div className="flex justify-end">
                  <input
                    type="text"
                    readOnly
                    placeholder=""
                    name=""
                    id=""
                    value={parseFloat(total).toFixed(2)}
                    className="mt-2 pl-10  pt-1 pb-1 w-32 bg-black text-white outline-none"
                  />
                </div>
                <div className="flex justify-between">
                  <div className="flex">
                    {type === "ADD" && (
                      <button
                        onClick={addVoucher}
                        className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 py-1 h-9 px-4 rounded"
                      >
                        <AiFillFileAdd className="mr-2 mt-1" />

                        <span>Add</span>
                      </button>
                    )}

                    {type === "SAVE" && (
                      <button
                        onClick={save}
                        className={`bg-blue-500 hover:bg-blue-700 flex h-9 text-white mt-3 py-1 px-4 rounded ${
                          isButtonDisabled
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                        disabled={isButtonDisabled}
                      >
                        <AiFillSave className="mt-1 mr-2 " />
                        <span>Save</span>
                      </button>
                    )}

                    {type === "ADD" && (
                      <button
                        onClick={edit}
                        className="bg-blue-500 hover:bg-blue-700 flex h-9 text-white mt-3 ml-3 py-1 px-4 rounded"
                      >
                        <AiFillEdit className="mr-2 mt-1" />

                        <span>Edit</span>
                      </button>
                    )}

                    <button
                      onClick={() => deletePurchase()}
                      className="bg-blue-500 hover:bg-blue-700 flex h-9 text-white mt-3 ml-3 py-1 px-4 rounded"
                      disabled={type !== "ADD"}
                    >
                      <AiFillDelete className="mr-2 mt-1" />

                      <span>Delete</span>
                    </button>
                    <button
                      onClick={() => {
                        clearStates();
                      }}
                      className="bg-blue-500 hover:bg-blue-700 flex h-9 text-white mt-3 ml-3 py-1 px-4 rounded"
                    >
                      {" "}
                      <BiExit className="mr-2 mt-1" />
                      {type === "EDIT" ? "Done" : "Exit"}
                    </button>
                  </div>
                  <div className="flex content-end mt-3 bg-white justify-end "></div>
                  {isVisible && (
                    <div>
                      <button
                        onClick={ascVoucher}
                        className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-2 py-1 px-4 rounded"
                      >
                        <img src={`./img/first.png`} alt="" />
                      </button>
                      <button
                        onClick={onePreVoucher}
                        className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-2 py-1 px-4 rounded"
                      >
                        <img src={`./img/previous.png`} alt="" />
                      </button>
                      <button
                        onClick={oneNextVoucher}
                        className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-2 py-1 px-4 rounded"
                      >
                        <img src={`./img/next.png`} alt="" />
                      </button>
                      <button
                        onClick={descVoucher}
                        className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-2 py-1 px-4 rounded"
                      >
                        <img src={`./img/latest.png`} alt="" />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Popup popup={editPopup} handlePopup={setEditpopup} onOk={editHandler}>
        <div>
          <h2>Please type voucher number</h2>
          <input
            style={{
              border: "1px solid",
            }}
            autoFocus
            type="number"
            value={voucher}
            onChange={(e) => setVoucher(e.target.value)}
          />
        </div>
      </Popup>

      <Popup
        popup={deletePopup}
        handlePopup={setDeletepopup}
        onOk={confirmDeleteAll}
      >
        <div>
          <h2>Please type voucher number for delete record</h2>
          <input
            style={{
              border: "1px solid",
            }}
            autoFocus
            type="number"
            value={voucher}
            onChange={(e) => setVoucher(e.target.value)}
          />
        </div>
      </Popup>
    </div>
  );
};

export default LubeSale;
